

































import {
  defineComponent, reactive, ref, watch,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import { createNotifyGroup, getNotifyGroup, updateNotifyGroup } from '@/api';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const PanelWithNotifyGroupEditor = defineComponent({
  components: {
    CommonModalWithPreset,
  },
  setup(props, { emit }) {
    const { route } = useRouter();
    const successModal = ref(null);
    const form = reactive({
      id: -1,
      name: '',
      token: '',
      type: '',
      call: async () => {
        if (route.value.params?.id) {
          await updateNotifyGroup(route.value.params.id, {
            name: form.name,
            token: form.token,
            type: form.type,
          });
        } else {
          await createNotifyGroup({
            name: form.name,
            token: form.token,
            type: form.type,
          });
        }
        (successModal.value as any).compose({ action: 'บันทึก', entity: 'กลุ่มแจ้งเตือน' });
        emit('done');
      },
    });

    async function callGetNotifyGroup() {
      const result = (await getNotifyGroup(route.value.params.id));
      form.id = result.id;
      form.name = result.name;
      form.token = result.token;
      form.type = result.type;
    }

    watch(() => route.value.params.id, async (newVal, oldVal) => {
      if (newVal !== oldVal && newVal) await callGetNotifyGroup();
    });

    return {
      form,
      successModal,
    };
  },
});

export default PanelWithNotifyGroupEditor;
